import type { CategoriesViewProps } from '../../types';
import * as React from 'react';
import { CollectionsB as CollectionsComponent } from '../../containers/CollectionsB';

export function View(props: CategoriesViewProps) {
  return (
    <>
      <CollectionsComponent {...props} />
    </>
  );
}
